import { createFileRoute } from '@tanstack/react-router';

import { WorkspaceEngagementResourceFormScreen } from '@/features/engagement-resources/components/WorkspaceEngagementResourceFormScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/engagement/resources/new')({
  beforeLoad: () => {
    requirePermission('engagement:create');
  },
  component: WorkspaceEngagementResourceCreateRoute,
  staticData: { crumb: 'New' },
});

function WorkspaceEngagementResourceCreateRoute() {
  return <WorkspaceEngagementResourceFormScreen mode="create" surface="workspace" />;
}
